<template>
   <span class="tarif" v-if="min !== null && Number.isInteger(min)">
      <template v-if="min > 0">
        {{ $t("message.a_partir_de") }} {{ min }} €
      </template>
      <template v-else>
        {{ $t("message.gratuit") }}
      </template>
    </span>
</template>
<script>
export default {
  name: 'TarifsView',   
  props: ['tarifs'],
  data: function() {
    return {
      min: null,
    }
  },
  methods : {
    getMin(tarifs) {
        tarifs.sort(function(a, b) { return a.MinimumEuro - b.MinimumEuro });
        let tarif = parseInt(tarifs[0].MinimumEuro);
        this.min = tarif;
    }
  },
  mounted() {
   this.getMin(this.tarifs);
  }
}
</script>
<style scoped>
  .tarif {
    background:white;
    padding: 2px 5px;
    border-radius: 5px;
    font-size:12px;
    font-weight:600;
    position:absolute;
    bottom:10px;
    right:5px;
    z-index: 1;
  }
</style>  